<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Regions</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in regions..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('countryIsoCode')">Country ISO code</th>
              <th class="col-1" @click="toggleSort('region')">Region</th>

              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.countryIsoCode">
              <td class="col-1 text-truncate" v-html="truncateText(config.countryIsoCode, 30)" @click="selectText" :data-text="config.countryIsoCode"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.region, 30)" @click="selectText" :data-text="config.region"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'RegionEdit', params: { id: config.countryIsoCode, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";

export default {
  name: "Regions",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      RegionList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc'
    };
  },
  computed: {
    filteredCouponsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.RegionList.filter((config) => {
        return (
            (config.countryIsoCode && config.countryIsoCode.toString().includes(search)) ||
            (config.region && config.region.toLowerCase().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredCouponsList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'countryIsoCode';
  },
  methods: {
    doLoadPlans() {
      AdminService.getRegionList().then((data) => {
        this.RegionList = data;
      }).catch((error) => {
        console.error("Error loading regions:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    },
    redirectToCreate() {
      this.$router.push({ name: 'RegionCreate' }); // Navigate to the StripeEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
  },
};
</script>
<style src="../../assets/style.css">
</style>
